import api from '../utils/api';

import DispatchConstants from '../constants/DispatchConstants';
import SingleFamilyContractDetails from '../model/SingleFamilyContractDetails';

const SingleFamilyEnterpriseActions = {
  getContracts() {
    return (dispatch) =>
      dispatch(api.users.singleFamilyEnterprise.getContracts()).then((response) => {
        if (response.success && response.response) {
          const contractsModel = response.response.contracts.map(SingleFamilyContractDetails);
          const hasAnyExpiredContract = response.response.hasAnyExpiredContract || false;
          dispatch({
            type: DispatchConstants.SINGLE_FAMILY_SET_CONTRACTS,
            payload: {
              contracts: contractsModel,
              hasAnyExpiredContract,
            },
          });
          return contractsModel;
        }
        return Promise.reject(response.error);
      });
  },
  setCustomerId(listingAlias, customerId) {
    return (dispatch) =>
      dispatch(api.users.singleFamilyEnterprise.setCustomerId(listingAlias, customerId)).then((response) => {
        if (response.success) {
          return { success: true };
        }
        return Promise.reject(response.error);
      });
  },
};

export default SingleFamilyEnterpriseActions;
